module.exports = __webpack_public_path__ + "img/app-recetas2.2e2ad38d.png";